<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">OSE GIOR</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <el-tooltip effect="dark"
                            content="Si está activada la opción, el sistema solo validará los comprobantes a través del OSE GIOR, y no podrá usar PSE GIOR y la configuración de Entorno de Sistema (SOAP Envio)."
                            placement="top">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                        <label class="control-label">Solo Validación OSE </label>
                        <el-switch v-model="form.is_ose_gior_validation_only"
                            active-text="Si"
                            inactive-text="No"
                            @change="submit"
                            disabled
                        ></el-switch>
                        <small v-if="errors.is_ose_gior_validation_only"
                            class="form-control-feedback"
                            v-text="errors.is_ose_gior_validation_only[0]"></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            resource: 'companies',
            form: {},
            errors: {},
            loading_submit: false,
        }
    },

    created() {
        this.initForm()
        this.getData()
    },

    methods: {
        initForm() {
            this.form = {
                is_ose_gior_validation_only: false,
            }
            this.errors = {}
        },

        getData() {
            this.$http.get(`/${this.resource}/record-send-pse`)
                .then(response => {
                    const { pse_providers, ...dataForm } = response.data
                    this.form = dataForm
                })
        },

        submit(){

            this.loading_submit = true
            this.$http.post(`/${this.resource}/active-ose-gior`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                    this.$eventHub.$emit('reloadDataCompany')
                })

        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/companies/ose_gior.vue